import { useDispatch, useSelector } from "react-redux";
import * as React from "react";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification/main/modal-notification.view";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";

import { RESOURCE_KEYS } from "../../../localization";
import { getViewHtmlId } from "../../focusHandling/sagas";

import { deleteProcessDocument } from "../actions";

const MODAL_RESOURCE_KEYS = RESOURCE_KEYS.features.deleteProcess;

export function DeleteProcessConfirmModal(props: View) {
	const { activityId } = props;

	const activity = useSelector(ActivitySelectors.activityById(activityId))!;

	const dispatch = useDispatch();
	const { localizer } = React.useContext(LocalizerContext);

	const onCancel = React.useCallback(() => {
		dispatch(ActivityActions.cancel({ activityId }));
	}, [dispatch, activity]);

	const onConfirmClick = React.useCallback(() => {
		if (activity.descriptor.instance && activity.initiatingActivityId) {
			dispatch(
				deleteProcessDocument({
					instanceId: activity.descriptor.instance,
					modalActivityId: activity.id,
					overviewActivityId: activity.initiatingActivityId
				})
			);
		}
	}, [dispatch, activity]);

	return (
		<ModalNotification
			id={getViewHtmlId(activityId)}
			variant="warning"
			onClose={onCancel}
			title={localizer({ key: MODAL_RESOURCE_KEYS.title })}
			footer={
				<ButtonGroup alignment="right">
					<Button label={localizer({ key: MODAL_RESOURCE_KEYS.cancel })} secondary onClick={onCancel} />
					<Button
						label={localizer({ key: MODAL_RESOURCE_KEYS.button })}
						destructive
						primary
						onClick={onConfirmClick}
					/>
				</ButtonGroup>
			}
		>
			<p>
				{localizer({
					key:
						activity.descriptor.createdAutomatically === "true"
							? MODAL_RESOURCE_KEYS.content.createdAutomatically
							: MODAL_RESOURCE_KEYS.content.createdManually
				})}
			</p>
		</ModalNotification>
	);
}
